import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const signUpStaff = createAsyncThunk(
  "staffInfo/signUpStaff",
  async (requestData) => {
    const { email, imageFile, firstName, lastName, externalId, role } =
      requestData;
    let formData = new FormData();

    if (imageFile) {
      formData.append("file", imageFile);
    }
    formData.append("externalId", externalId);
    formData.append("role", role);
    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    return await userService.signUpStaff(formData);
  }
);

export const fetchStaff = createAsyncThunk(
  "staffInfo/fetchStaff",
  async (requestData) => {
    const { page, sortBy, order, search } = requestData;
    return await userService.fetchStaff(page, sortBy, order, search);
  }
);

export const editStaff = createAsyncThunk(
  "staffInfo/editStaff",
  async (requestData) => {
    const { email, imageFile, firstName, lastName, externalId, role, id } =
      requestData;
    let formData = new FormData();

    if (imageFile) {
      formData.append("file", imageFile);
    }
    formData.append("id", id);
    formData.append("externalId", externalId);
    formData.append("role", role);
    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    return await userService.editStaff(formData);
  }
);
